import { render, staticRenderFns } from "./approveVenue.vue?vue&type=template&id=f62c8042&scoped=true"
import script from "./approveVenue.vue?vue&type=script&lang=js"
export * from "./approveVenue.vue?vue&type=script&lang=js"
import style0 from "./approveVenue.vue?vue&type=style&index=0&id=f62c8042&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62c8042",
  null
  
)

export default component.exports